import { History } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface RequirementTimelineEvent {
  cdreqevent: number;
  idevent: string;
  dtevent: string;
  txcontent?: string | null;
}

interface RequirementTimelineDialogProps {
  open: boolean;
  events: RequirementTimelineEvent[];
  onOpenChange: (open: boolean) => void;
}

const eventLabels: Record<string, string> = {
  requested: "Requerimento solicitado",
  file_uploaded: "Arquivo enviado",
  comment_added: "Comentário adicionado",
  approved: "Arquivo aprovado",
  rejected: "Arquivo reprovado",
  replaced: "Documento substituído",
  notified: "Cobrança enviada",
  expired: "Documento vencido",
  propagated: "Requerimento propagado",
  discontinued: "Requerimento descontinuado",
};

export function RequirementTimelineDialog({
  open,
  events,
  onOpenChange,
}: RequirementTimelineDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] overflow-hidden sm:max-w-xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <History className="size-5 text-primary" />
            Timeline do requerimento
          </DialogTitle>
          <DialogDescription>
            Acompanhe os eventos registrados em ordem cronológica.
          </DialogDescription>
        </DialogHeader>

        <div className="max-h-[60vh] overflow-y-auto pr-2">
          {events.length === 0 ? (
            <p className="rounded-xl border border-dashed p-5 text-center text-sm text-muted-foreground">
              Ainda não há eventos registrados.
            </p>
          ) : (
            <ol className="space-y-0">
              {events.map((event, index) => (
                <li key={event.cdreqevent} className="relative flex gap-3 pb-5 last:pb-0">
                  {index < events.length - 1 && (
                    <span className="absolute left-[5px] top-3 h-full w-px bg-border" />
                  )}
                  <span className="relative mt-1.5 size-3 shrink-0 rounded-full border-2 border-primary bg-background" />
                  <div className="min-w-0 flex-1 rounded-xl border bg-muted/25 px-4 py-3">
                    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                      <p className="text-sm font-medium text-foreground">
                        {eventLabels[event.idevent] || event.idevent}
                      </p>
                      <time className="text-xs text-muted-foreground">
                        {new Date(event.dtevent).toLocaleString("pt-BR")}
                      </time>
                    </div>
                    {event.txcontent && (
                      <p className="mt-2 whitespace-pre-wrap text-sm text-muted-foreground">
                        {event.txcontent}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ol>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
